import React, { useState, useEffect } from 'react';
import translations from '../../translations';
import { isNullOrEmpty } from '../../utils/core';
/**
 * Side menu UI component that used for navigation within a page
 *
 * @param {Array} items Set of links for the side menu
 * @param {Array} activeSectionId Currently active section id
 */
export const PageSideMenu = ({ items, activeSectionId }) => {
    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        setMenuItems(items);
    }, [menuItems]);

    const [navByClick, setNavByClick] = useState(false);

    const updateSelected = (current, menuClick) => {
        // remember the original navigation method (click or scroll)
        if (menuClick) {
            setNavByClick(true);
        } else {
            setNavByClick(false);
        }

        // since clicking also scrolls the page there is no need to update the
        // highlight again based on scrollspy if we originally clicked on a link
        // to navigate
        if (!menuClick && navByClick) return;

        const updatedMenuItems = menuItems.map((item) => {
            item.active = item.link === current;
            return item;
        });

        setMenuItems(updatedMenuItems);
    };

    // update the side-menu based on the scrollspy
    useEffect(() => {
        if (activeSectionId) {
            updateSelected(`#${activeSectionId}`, false);
        }
    }, [activeSectionId]);

    const buildItem = (item, index) => (
        <li key={`${item.label}-${index}`} className="menu-item">
            <a
                className={`${item.active ? 'menu-link active' : 'menu-link'}`}
                href={item.link}
                onClick={() => updateSelected(item.link, true)}
            >
                {item.label}
            </a>
        </li>
    );

    const buildMenu = () => menuItems.filter(item => isNullOrEmpty(item.visible) ? true : item.visible).map((item, index) => buildItem(item, index));

    return (
        <nav>
            <h5 className="menu-heading">{translations.SIDE_MENU_TITLE}</h5>
            <ul className="menu-list">
                {buildMenu()}
            </ul>
        </nav>
    );
};

export default PageSideMenu;
